import * as React from "react";
import type { SVGProps } from "react";
const SvgEyeonIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="eyeon_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M271.275 338.859C209.152 392.96 162.688 459.819 130.347 512c32.341 52.181 78.805 119.04 140.928 173.141 63.018 54.827 141.909 96.384 238.506 96.384 96.555 0 175.488-41.557 238.507-96.426C810.411 631.04 856.832 564.18 889.216 512c-32.384-52.181-78.805-119.04-140.97-173.141-62.977-54.827-141.867-96.384-238.507-96.384-96.555 0-175.446 41.557-238.464 96.384zM125.355 512C190.293 406.741 313.94 238.208 509.78 238.208c-195.84 0-319.488 168.533-384.426 273.792zm-70.528-42.837c63.701-103.254 209.066-313.43 454.954-313.43s391.254 210.176 454.955 313.43a81.493 81.493 0 0 1 0 85.674c-63.701 103.254-209.067 313.43-454.955 313.43S118.528 658.09 54.827 554.795a81.536 81.536 0 0 1 0-85.632zm454.954-31.147a73.941 73.941 0 1 0 0 147.925 73.941 73.941 0 0 0 0-147.882zM349.013 512a160.725 160.725 0 1 1 321.451 0 160.725 160.725 0 0 1-321.45 0z"
    />
  </svg>
);
export default SvgEyeonIcon;
